import React from "react";

function Backup() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      className="lucide lucide-cloud-upload"
      viewBox="0 0 24 24"
    >
      <path d="M12 13v8M4 14.899A7 7 0 1115.71 8h1.79a4.5 4.5 0 012.5 8.242"></path>
      <path d="M8 17l4-4 4 4"></path>
    </svg>
  );
}

export default Backup;
